
import { jsonp } from '../assets/js/common.js';
import Card from 'vux/src/components/card/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Countup from 'vux/src/components/countup/index.vue'
import Masker from 'vux/src/components/masker/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
created() {
jsonp(`/subject/${this.$route.params.id}`).then(res => {

this.$nextTick(() => {
this.$refs.scrollerEvent.reset({ top: 0 })
});
this.isLoadMoreShow = false;
this.previewerList = [{
w: 300,
h: 419,
src: res.images.large
}];

this.dataList = res;
this.dataList.aka = res.aka.join('、');
this.dataList.countries = res.countries.join('、');
this.dataList.genres = res.genres.join('、');
this.dataList.star = res.rating.stars / 20;
this.dataList.average = res.rating.average;
this.dataList.stars = res.rating.stars;

setTimeout(() => {
this.$refs.scrollerEvent.reset({ top: 0 });
}, 250);
}).catch(ex => {
console.error(ex);
});
},
methods: {

show() {
this.$refs.previewer.show(0);
},

changeTextState() {
this.isTextHide = !this.isTextHide;
},

toRoute(id) {
this.$router.push({ path: `/celebrity/${id}` });
}
},
data() {
return {
dataList: [],
previewerList: [],
isTextHide: true,
isLoadMoreShow: true,
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }


}
}
}
},
components: {
Card,
Previewer,
CellBox,
Scroller,
Rater,
LoadMore,
Flexbox,
FlexboxItem,
Countup,
Masker,
Divider,
Cell
},
directives: {
TransferDom
},
props: ['heightData']
}



// WEBPACK FOOTER //
// ./src/components/MovieDetail.vue